import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { observer } from "mobx-react";

interface IProps {
  hasSidebar?: boolean;
  hideSidebar?: boolean;
  hideFooter?: boolean;
  sidebarLayout?: 1 | 2;
}

const Layout: React.FC<IProps> = observer(
  ({ children, hasSidebar, hideSidebar, hideFooter, sidebarLayout }) => {
    return (
      <>
        {!hideSidebar && (
          <Header hasSidebar={hasSidebar} sidebarLayout={sidebarLayout} />
        )}
        {children}
        {!hideFooter && <Footer />}
      </>
    );
  }
);

Layout.defaultProps = {
  hideFooter: false,
  hideSidebar: false,
};

export default Layout;
